import { GerenciadorPrecos } from '../../../@types/GerenciadorPrecos';
import { FiltersValueState } from '../../../reducers/gerenciadorPrecos/filters/filtersValues';

export const cascadingCategoryKeys = [
  'categoryLevel1',
  'categoryLevel2',
  'categoryLevel3',
  'categoryLevel4',
  'categoryLevel5',
  'categoryLevel6',
  'categoryLevel7',
] as const;

const cascadingFilterKeys = ['productIds', 'productFamilyIds', ...cascadingCategoryKeys] as const;

type CascadingFilterKey = (typeof cascadingFilterKeys)[number];

export type CascadingFilterParams = Partial<Record<'productId' | 'productFamilyId' | (typeof cascadingCategoryKeys)[number], string[]>>;

const paramKeyByFilterKey: Record<CascadingFilterKey, keyof CascadingFilterParams> = {
  productIds: 'productId',
  productFamilyIds: 'productFamilyId',
  categoryLevel1: 'categoryLevel1',
  categoryLevel2: 'categoryLevel2',
  categoryLevel3: 'categoryLevel3',
  categoryLevel4: 'categoryLevel4',
  categoryLevel5: 'categoryLevel5',
  categoryLevel6: 'categoryLevel6',
  categoryLevel7: 'categoryLevel7',
};

export const isCascadingFilterKey = (key: string): key is CascadingFilterKey => {
  return (cascadingFilterKeys as readonly string[]).includes(key);
};

export const getCascadingFilterParams = (values: FiltersValueState, currentKey: GerenciadorPrecos.FilterKeys): CascadingFilterParams => {
  if (!isCascadingFilterKey(currentKey)) return {};

  return cascadingFilterKeys.reduce<CascadingFilterParams>((params, key) => {
    if (key === currentKey) return params;

    const value = values[key];
    if (!Array.isArray(value) || !value.length) return params;

    params[paramKeyByFilterKey[key]] = value;
    return params;
  }, {});
};

export const hasCascadingFilterParams = (params: CascadingFilterParams): boolean => {
  return Object.values(params).some(value => Array.isArray(value) && value.length);
};

export const getCascadingFilterParamsSignature = (params: CascadingFilterParams): string => {
  return Object.entries(params)
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([key, value]) => `${key}:${value.join('|')}`)
    .join(';');
};
